import type { DeliverySlot } from '@@partner:types:app'
import { GQL_ID, GQL_TIMESTAMP } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'

export interface SlotInfoInput {
  id?: GQL_ID
  shop_id?: GQL_ID
  zone_id?: GQL_ID
  ts_start?: GQL_TIMESTAMP
  ts_end?: GQL_TIMESTAMP
  orders_capacity: number
  position_capacity: number
  timeout: number
}

export interface UpdateSlotInfo {
  slot: DeliverySlot
}

export interface UpdateSlotInfoVariables {
  slotInfo: SlotInfoInput
  upsert: boolean
}

export const GQL_MUTATION_UPDATE_SHOP_SLOT_INFO = gql`
  mutation ($slotInfo: SlotInfoInput, $upsert: Boolean) {
    updateSlot(newData: $slotInfo, upsert: $upsert) {
      id
      slotTime
      period {
        from
        to
      }
      shop_id
      zone_id
      shop {
        id
        name
        address
        tzOffset
      }
      deliveryZone {
        id
        name
        tzOffset
      }
      availableUntil
    }
  }
`

export const useMutateUpdateShopSlotInfo = () => {
  return useMutation<UpdateSlotInfo, UpdateSlotInfoVariables>(
    GQL_MUTATION_UPDATE_SHOP_SLOT_INFO
  )
}
